module.exports = __webpack_public_path__ + "media/images/bg_recipes-b6af611258a875eeb012d1d84eff4ad5.webp";